import { render, staticRenderFns } from "./UpdateTeamSettings.vue?vue&type=template&id=054b2284&"
import script from "./UpdateTeamSettings.vue?vue&type=script&lang=js&"
export * from "./UpdateTeamSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports